import { ListOfTeamResponse } from './Api/ListOfTeam.response';

export class TeamEntity extends ListOfTeamResponse {
	public static tryCast(o: any): TeamEntity {
		const ret = new TeamEntity();
		return Object.assign(ret, o);
	}
}
